var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "duplicate-expedient-container" },
    [
      _c(_setup.CustomDialogHeaderComponent, {
        attrs: { headerTitle: _setup.texts.title },
      }),
      _c(
        "div",
        { staticClass: "buttons-container" },
        [
          _c(_setup.LexonTextFieldComponent, {
            attrs: {
              label: _setup.texts.nameLabel,
              id: "name",
              name: "name",
              validationRules: "required",
            },
            model: {
              value: _setup.expedientName,
              callback: function ($$v) {
                _setup.expedientName = $$v
              },
              expression: "expedientName",
            },
          }),
          _c(_setup.LexonAutocompleteComponent, {
            attrs: {
              id: "sections",
              name: "sections",
              propItems: _setup.sections,
              label: _setup.texts.sectionsLabel,
              multiple: "",
              chips: "",
              hasRelatedField: "",
              itemName: "name",
              itemValue: "id",
              validationRules: "required",
              showSelectAll: true,
              selectAllText: _setup.texts.allSections,
            },
            model: {
              value: _setup.selectedSections,
              callback: function ($$v) {
                _setup.selectedSections = $$v
              },
              expression: "selectedSections",
            },
          }),
        ],
        1
      ),
      _c(_setup.CustomDialogActionButtonsComponent, {
        attrs: {
          disabledButtons: _setup.disabledActionButton,
          mainAction: _setup.duplicateExpedient,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }